import React, { Component, Fragment } from 'react';
import classNames from 'classnames';

class TextInput extends Component {
  render() {
    const {
      type,
      id,
      label,
      name,
      required,
      maxLength,
      onChange,
      errorMessage,
      valid,
      value,
    } = this.props;

    return (
      <Fragment>
        <label
          htmlFor={id}
          className={classNames('text-input', 'pt-3', {
            'text-input--error': !valid && errorMessage !== '',
          })}
        >
          {label} {required && <span className="text-input__required" />}
          <input
            className="text-input__input"
            value={value}
            type={type}
            id={id}
            name={name}
            required={required}
            maxLength={maxLength}
            onChange={onChange}
          />
          {!valid && errorMessage !== '' && (
            <span className="text-input__error-hint">
              {label + errorMessage}
            </span>
          )}
        </label>
      </Fragment>
    );
  }
}

export default TextInput;
